import BaseService from '@src/services/BaseService'

class QuestionnairesService extends BaseService {
    constructor() {
        super('questionnaires')
    }
}

export default new QuestionnairesService()
